import { effect, linkedSignal, ResourceRef } from '@angular/core';

export function ifNotError<T>(source: ResourceRef<T>, defaultValue: T = undefined) {
  effect(() => {
    if (source.error()) console.log('resource has error: ', source.error());
  });
  return linkedSignal({
    source: source.snapshot,
    computation: snapshot => (snapshot.status == 'resolved' ? snapshot.value : defaultValue),
  });
}
